import {makeStyles} from '@material-ui/core/styles';
import {Colors} from '../../../styles/Colors';

export interface AccountDetailsProps {
    id: string;
}

export const useStyles = makeStyles(() => ({
    mainContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
    },
    loaderContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    statusActive: {
        color: Colors.Support,
    },
    statusSuspended: {
        color: Colors.Primary2,
    },
    statusInactive: {
        color: Colors.Gray5,
    },
    actionsPanel: {
        maxWidth: 992,
    },

    '@media (max-width: 1276px)': {
        actionsPanel: {
            left: 41,
            width: 'calc(100% - 146px)'
        },
    },
    '@media (min-width:1277px) and (max-width: 1440px)': {
        actionsPanel: {
            left: 107,
            width: 'calc(100% - 278px)'
        },
    },
    '@media (min-width: 1441px)': {
        actionsPanel: {
            left: 113,
            maxWidth: 992,
            width: 'calc(100% - 290px)'
        },
    },
}));

export const useHeaderStyles = makeStyles(() => ({
    headerContainer: {
        backgroundColor: Colors.White,
        display: 'flex',
        flexDirection: 'column',
    },
    headerTop: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    leftContainer: {
        display: 'flex',
        alignItems: 'center',
        color: Colors.Text,
        fontSize: 32,
        lineHeight: '36px',
        fontWeight: 300,
    },
    rightContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    backButton: {
        marginRight: 10,
    },
    accountId: {
        fontWeight: 500,
        marginLeft: 16,
    },
    statusCell: {
        display: 'flex',
        flexDirection: 'column',
    },
    statusBadge: {
        display: 'flex',
        alignItems: 'center',
    },
    statusDot: {
        display: 'inline-flex',
        marginRight: 9,
        width: 10,
        height: 10,
        borderRadius: 25,
        flexShrink: 0,
    },
    statusDotActive: { backgroundColor: Colors.Support },
    statusDotNotYetActive: { backgroundColor: Colors.Link },
    statusDotSuspended: { backgroundColor: Colors.Primary2 },
    statusDotInactive: { backgroundColor: Colors.Gray9 },
    statusText: {
        fontSize: 16,
        fontWeight: 500,
    },
    statusActive: { color: Colors.Support },
    statusNotYetActive: { color: Colors.Link },
    statusSuspended: { color: Colors.Primary2 },
    statusInactive: { color: Colors.Gray9 },
    lastUsed: {
        fontSize: 12,
        color: Colors.Gray9,
    },
    statusSwitcher: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 33,
        fontWeight: 500,
        color: Colors.Text,
    },
    switch: {
        marginBottom: -10,
    },
}));

